<template>
  <Button
    :data-size="props.size"
    :variant="props.variant"
    :class="cn(inputGroupButtonVariants({ size: props.size }), props.class)"
  >
    <slot />
  </Button>
</template>

<script setup>
import { Button } from '@/shadcn/components/ui/button'
import { cn } from '@/shadcn/lib/utils'
import { inputGroupButtonVariants } from '.'

const props = defineProps({
  size: { type: null, required: false, default: 'xs' },
  variant: { type: null, required: false, default: 'ghost' },
})
</script>
